import { Box, Heading, VStack } from "@chakra-ui/react"
import Breadcrumbs from "@components/Product/Breadcrumbs"

type RelatedCategoriesProps = {
  category: {
    name: string
    termCode: string
  }[]
}
const RelatedCategories = ({ category }: RelatedCategoriesProps) => {
  return (
    <Box>
      <Heading size={"md"}>{"Related Categories"}</Heading>
      <VStack
        w={"100%"}
        spacing={2}
        fontSize={"sm"}
        alignItems={"flex-start"}
        mt={4}
      >
        <Breadcrumbs category={category} />
      </VStack>
    </Box>
  )
}

export default RelatedCategories
